import styled from '@emotion/styled';
import { css, SerializedStyles, Theme } from '@emotion/react';

import { Global } from '../../styles';

type PlaneBackgroundStyle = 'green' | 'mint' | 'orange';

const getPlaneBackground = (
  theme: Theme,
  style: PlaneBackgroundStyle,
): SerializedStyles =>
  ({
    green: css`
      background-color: ${theme.colors.brand.green40};
    `,
    mint: css`
      background-color: ${theme.colors.brand.green20};
    `,
    orange: css`
      background-color: ${theme.colors.brand.orange40};
    `,
  })[style];

const PlaneBackgroundContainer = styled.div<{
  backgroundStyle: PlaneBackgroundStyle;
}>`
  ${Global.layoutContainerContent};

  ${({ theme, backgroundStyle }) => getPlaneBackground(theme, backgroundStyle)};

  &:empty {
    display: none;
  }

  &:not(:empty) {
    padding-block: 2.5rem;
  }
`;

export { PlaneBackgroundContainer };
export type { PlaneBackgroundStyle };
